import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import { Badge, IconButton } from '@mui/material';
import './styles.css'
import { sxNotificationIconButton } from './sxProps';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getComunicadosBenef } from '../../services/ComunicadoService';
import { ComunicadosBenef } from '../../interfaces/entities/ComunicadosBenef';
import { TypeNotificationEnum } from '../../interfaces/enum/TypeNotificationEnum';
import { useNotification } from '../../Store/contexts/NotificationContext';

function Notification() {

  const navigate = useNavigate();
  const { unreadNotificationsNumber } = useNotification();

  return (
    <IconButton
      aria-label={`${unreadNotificationsNumber} notificações`}
      size='large'
      onClick={() => navigate(`/notificacoes/${TypeNotificationEnum.Notificacoes}`)}
    >
      <Badge
        color="error"
        badgeContent={unreadNotificationsNumber}
        overlap='circular'
      >
        <FontAwesomeIcon icon={faBell} size="1x" className='notification-bell' />
      </Badge>
    </IconButton>
  );
}

export default Notification;